/*
  PULLORAX — product alert dialog.

  Two jobs:
    1. open/close the dialog with a proper focus trap
    2. stamp the product being asked about onto the form, so the captured
       email is tagged with that product's handle and the interest list is
       filterable per product in the Shopify admin

  The dialog's copy and form live in sections/pullorax-global-extras.liquid.
*/
(function () {
  'use strict';
  var modal, titleEl, tagsEl, previousFocus;

  function qs(s, r) { return (r || document).querySelector(s); }

  function focusable() {
    if (!modal) return [];
    return Array.prototype.slice.call(modal.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  // Tags must stay a safe, predictable shape: Shopify splits on commas.
  function cleanHandle(h) {
    return String(h || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 80);
  }

  // The fallback button label below, in the page's language. <html lang> is
  // en, fr, de or he; anything else gets the English label.
  function notifyLabel() {
    var lang = String(document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    var labels = { it: 'AVVISAMI', en: 'NOTIFY ME', fr: 'ME PRÉVENIR', de: 'BENACHRICHTIGEN', he: 'הודיעו לי' };
    return labels[lang] || labels.en;
  }

  function open(btn) {
    modal = modal || qs('[data-px-notify-modal]');
    if (!modal) return;
    titleEl = qs('[data-px-notify-product]', modal);
    tagsEl = qs('#pxNotifyTags', modal);

    var title = (btn && btn.dataset.title) || ((qs('.px-pdp__title') || {}).textContent) || '';
    title = String(title).trim();
    var handle = cleanHandle((btn && btn.dataset.handle) || location.pathname.split('/').filter(Boolean).pop());

    if (titleEl) titleEl.textContent = title;
    if (tagsEl) tagsEl.value = handle ? 'back-in-stock,' + handle : 'back-in-stock';

    previousFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      var email = qs('#pxNotifyEmail', modal);
      if (email) { email.focus(); return; }
      var items = focusable();
      if (items.length) items[0].focus();
    }, 30);
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    // WCAG 4.1.2: focus must leave the dialog BEFORE it is hidden from
    // assistive technology, otherwise aria-hidden="true" ends up on an ancestor
    // of the focused element. Restore first, hide second.
    if (previousFocus && previousFocus.focus) {
      previousFocus.focus();
    } else if (document.activeElement && modal.contains(document.activeElement) && document.activeElement.blur) {
      document.activeElement.blur();
    }
    modal.setAttribute('aria-hidden', 'true');
  }

  /*
    WCAG 3.3.1. {% form 'customer' %} posts and reloads the page, and the dialog
    is display:none until .is-open is on it — so a validation error came back on
    a page where it could never be seen. When the section has rendered the error
    paragraph (it carries data-px-notify-error) the dialog is re-opened here and
    focus is moved to the email field, which is wired to that paragraph through
    aria-describedby and marked aria-invalid. previousFocus stays empty — there
    is nothing to return to on a fresh document — and close() handles that case.
  */
  function adoptServerOpen() {
    if (!modal) return;
    var errored = !!qs('[data-px-notify-error]', modal);
    if (!errored && !modal.classList.contains('is-open')) return;
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    document.documentElement.style.overflow = 'hidden';
    previousFocus = null;
    var email = qs('#pxNotifyEmail', modal);
    if (email) {
      try { email.focus(); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-px-notify]');
    if (b) { e.preventDefault(); e.stopPropagation(); open(b); return; }
    if (e.target.closest('[data-px-notify-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var items = focusable();
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // FALLBACK ONLY. sections/pullorax-product.liquid now renders a real
  // [data-px-notify] trigger in the buy box and in the sticky bar, with a
  // translated label. Where that trigger is present this must do nothing, or
  // the page shows two alert buttons and the disabled ADD TO CART loses the
  // availability label it is carrying. On any older template that still has a
  // dead disabled button and no trigger, the button becomes the trigger — that
  // is the only action such a page can offer.
  function upgradePdp() {
    var title = ((qs('.px-pdp__title') || {}).textContent || '').trim();
    var handle = location.pathname.split('/').filter(Boolean).pop() || '';
    ['.px-pdp__buy', '.px-buybar'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (box) {
        if (box.querySelector('[data-px-notify]')) return;
        box.querySelectorAll('button[disabled]').forEach(function (btn) {
          btn.disabled = false;
          btn.type = 'button';
          btn.removeAttribute('form');
          btn.dataset.pxNotify = '';
          btn.dataset.handle = handle;
          btn.dataset.title = title;
          btn.textContent = notifyLabel();
          btn.classList.add('pd__notify-trigger');
        });
      });
    });
  }

  /*
    WCAG 4.1.3. The confirmation toast carries its visible text at first paint
    (so nothing depends on this running) plus an EMPTY live region beside it. A
    role="status" region that already holds its text when the page paints is read
    in document order and never announced, so the text is copied into the live
    region a moment after load — that mutation is what an assistive technology
    actually reports.
  */
  function announceToast() {
    var toast = qs('[data-px-toast]');
    if (!toast) return;
    var src = qs('[data-px-toast-text]', toast);
    var live = qs('[data-px-toast-live]', toast);
    if (!src || !live) return;
    setTimeout(function () {
      live.textContent = (src.textContent || '').trim();
    }, 200);
  }

  document.addEventListener('DOMContentLoaded', function () {
    modal = qs('[data-px-notify-modal]');
    upgradePdp();
    adoptServerOpen();
    announceToast();
    // Clear the success flag from the URL so a refresh does not re-toast.
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('customer_posted')) {
        u.searchParams.delete('customer_posted');
        window.history.replaceState({}, '', u.toString());
      }
    } catch (e) {}
  });
})();